import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'

Vue.use(VueResource);

// send the request as application/x-www-form-urlencoded
Vue.http.options.emulateJSON = true;

var isProduction = process.env.NODE_ENV === 'production';
var rootUrl = (isProduction) ? 'https://colla.spush.org' : 'http://localhost:8001';
Vue.http.options.root = rootUrl;
Vue.http.options.api = rootUrl + '/api';

Vue.config.ignoredElements = [
    'colla'
];

new Vue({
  el: '#collapp',
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js